import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { PopupContent } from '../../state/application/reducer';
import { useRemovePopup } from '../../state/application/hooks';
import { screenUp } from '../../utils/styles';
import { ErrorPopup } from './ErrorPopup';
import { TransactionPopup } from './TransactionPopup';
import { WaitingPopup } from './WaitingPopup';

interface PopupItemProps {
  popupId: string;
  content: PopupContent;
  removeAfterMs: number | null;
}

export const PopupItem: React.FC<PopupItemProps> = ({ removeAfterMs, popupId, content }) => {
  const removePopup = useRemovePopup();
  const removeThisPopup = useCallback(() => removePopup(popupId), [popupId, removePopup]);
  useEffect(() => {
    if (removeAfterMs == null) return undefined;

    const timeout = setTimeout(() => {
      removeThisPopup();
    }, removeAfterMs);

    return () => {
      clearTimeout(timeout);
    };
  }, [removeAfterMs, removeThisPopup]);

  let contentDiv = null;

  switch (content.type) {
    case 'waiting':
      contentDiv = <WaitingPopup {...content} />;
      break;
    case 'error':
      contentDiv = <ErrorPopup {...content} />;
      break;
    case 'transaction':
      contentDiv = <TransactionPopup {...content} />;
      break;
  }

  return (
    <StyledPopup>
      <StyledClose onClick={removeThisPopup}></StyledClose>
      {contentDiv}
    </StyledPopup>
  );
};

const StyledPopup = styled.div`
  background-color: #f4f4f4;
  border-style: solid;
  border-color: #becfd4;
  border-width: 1px 1px 1px 0;
  border-radius: 5px;
  padding: 20px 15px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08);
  position: relative;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 20px;
  ${screenUp('md')`
    padding: 15px;
  `}
`;

const StyledClose = styled.button.attrs({
  children: <i className="far fa-times" />,
})`
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 0;
  opacity: 0.4;
  color: #7a797f;
  font-size: 20px;
  ${screenUp('md')`
    font-size: 16px;
  `}
`;
